import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

const DividerDefaultBox = styled.div<{marginTop?: string; marginBottom?: string;}>`
    box-sizing: content-box;
    height: 1px;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
    margin-top: ${({marginTop}) => marginTop ? marginTop : "unset"};
    margin-bottom: ${({marginBottom}) => marginBottom ? ("calc(" + marginBottom + " + 1px)") : "1px"};
`;

const DividerCasino777Box = styled(DividerDefaultBox)`
    box-shadow: 0px 0.25px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
`;

const DividerSiBox = styled(DividerDefaultBox)`
    box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderLighter};
`;

export const DividerBox = styledByTheme(DividerDefaultBox)
    .forCasino777(DividerCasino777Box)
    .forSI(DividerSiBox)
    .apply();